export default __webpack_public_path__ + "static/media/LePtitRetro60s.9dd5162f.mp3";